import { FormikHelpers } from "formik";
import { useCreateAtmCompany } from "./api/createAtmCompany";
import AtmCompanyForm from "./AtmCompanyForm";


const CreateAtmCompany = ({handleCloseModal}: CreateAtmCompanyProps)  => {
  const createAtmCompanyMutation = useCreateAtmCompany({data: {}});

  const initialValues: IPostNewAtmCompany = {
    description: "",
    deleted: false
  };

  const handleSubmit = async (values: IPostNewAtmCompany, { setSubmitting }: FormikHelpers<IPostNewAtmCompany>): Promise<void> => {
    try {
      await createAtmCompanyMutation.mutateAsync({
        data: values,
      });
      handleCloseModal();
    } catch (error) {
      console.log(error);
      console.log("values", values);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AtmCompanyForm initialValues={initialValues} type="create" onSubmit={handleSubmit} />
  )
}

interface CreateAtmCompanyProps {
  handleCloseModal: () => void;
}

export default CreateAtmCompany;